const composeBorderRadiusProperty = (
  values: Record<string, string | null>,
): string | null => {
  const {
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderBottomLeftRadius,
    // Note: Logical properties are NOT atomics of border-radius shorthand,
    // so they should NOT be used for composition. They are separate CSS properties.
  } = values;

  // Check if at least one physical atomic is explicitly set
  const hasPhysicalValue =
    borderTopLeftRadius !== undefined ||
    borderTopRightRadius !== undefined ||
    borderBottomRightRadius !== undefined ||
    borderBottomLeftRadius !== undefined;

  // Can't compose if no physical atomics are set
  if (!hasPhysicalValue) {
    return null;
  }

  // Only use physical atomics (from border-radius decomposition)
  // Default to '0px' for unset atomics to enable partial compositions
  const topLeft = borderTopLeftRadius ?? '0px';
  const topRight = borderTopRightRadius ?? '0px';
  const bottomRight = borderBottomRightRadius ?? '0px';
  const bottomLeft = borderBottomLeftRadius ?? '0px';

  // All corners are the same (including '0')
  if (
    topLeft === topRight &&
    topRight === bottomRight &&
    bottomRight === bottomLeft
  ) {
    return topLeft;
  }

  // Top-left/bottom-right same, top-right/bottom-left same
  if (topLeft === bottomRight && topRight === bottomLeft) {
    return `${topLeft} ${topRight}`;
  }

  // Bottom-left same as top-right
  if (bottomLeft === topRight) {
    return `${topLeft} ${topRight} ${bottomRight}`;
  }

  // All different
  return `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`;
};

export const cornerComposeMap = {
  borderRadius: composeBorderRadiusProperty,
};
